import React from "react";

import Reports from "../Reports";
import Dashboard from "../Dashboard";
import ReportBreach from "../ReportBreach";
import StorageSearch from "../StorageSearch";
import ClientAccount from "../ClientAccount";
import ClientForms from "../ClientForms";
import GenericError from "../Shared/GenericError";
import SecLayout from "../Layouts/SecLayout";
import oasisLogo from "../../assets/logos/Logo-Oasis.svg";
import defaultErrorImg from "../../assets/cubert/dead.png";
import ClientOrder from "../ClientForms/Forms/ClientForm";
import ClientOrderCompleted from "../ClientForms/Forms/ClientForm/Info";
import ContactClientCare from "../ClientForms/Forms/ContactClientCare";
import ContactClientCareCompleted from "../ClientForms/Forms/ContactClientCare/Info";

export const VIEW_REPORTS = "REPORTS";
export const VIEW_DASHBOARD = "DASHBOARD";
export const VIEW_CLIENTFORMS = "REPORTBREACH";
export const VIEW_REPORTBREACHINFO = "REPORTBREACH";
export const VIEW_STORAGE_SEARCH = "STORAGE SEARCH";
export const VIEW_HOME = "HOME";
export const VIEW_ADMIN = "ADMIN";
export const VIEW_ADMIN_MYDASHBOARD = "MYDASHBOARD";
export const VIEW_CLIENT_ACCOUNT = "CLIENTACCOUNT";

const exact = true;
const NavLinks = [
  {
    title: "Dashboard",
    path: "/dashboard",
    iconName: "omni-dashboard-nav",
  },
  {
    title: "StorageSearch",
    path: "/storage-search",
    iconName: "icon-omni-search",
    condition: (user) =>
      user.features &&
      user.features.length > 0 &&
      user.features.find((f) => f.featureType === 0) &&
      user.features.find((f) => f.featureType === 0).isEnabled,
  },
  {
    title: "ClientAccount",
    path: "/client-account",
    iconName: "omni-darkmode-active",
    condition: (user) => checkSelfServicePermission(user),
  },
  {
    title: "Reports",
    path: "/reports",
    iconName: "icon-omni-Reports-Nav",
    condition: (user) =>
      user.tr_employeeId &&
      user.features &&
      user.features.length > 0 &&
      user.features.find((f) => f.featureType === 1) &&
      user.features.find((f) => f.featureType === 1).isEnabled,
  },
  {
    title: "ClientForms",
    path: "/client-forms",
    iconName: "icon-omni-stamped-document",
  },
  { title: "ContactUs" },
];

const secLayout = (component, condition) => (
  <SecLayout
    siteName="ClientHub"
    condition={condition}
    pages={NavLinks}
    logo={oasisLogo}
    announcementBroadcastDestinations={[0, 2]}
    applicationType={0}
    siteConfigurations={{
      canChangePassword: (user) => {
        return !(
          user.portal_haspermission_TR && user.portal_haspermission_TR === "YES"
        );
      },
    }}
  >
    {component}
  </SecLayout>
);

export const checkSelfServicePermission = (user) => {
  if (user.portal_haspermission_TR && user.portal_haspermission_TR === "YES") {
    return true;
  }
  return false;
};

export const ClientHubRoutes = [
  {
    exact,
    path: "/",
    component: () => secLayout(Dashboard),
  },
  {
    exact,
    path: "/storage-search",
    component: () =>
      secLayout(
        StorageSearch,
        (user) =>
          user.features &&
          user.features.length > 0 &&
          user.features.find((f) => f.featureType === 0) &&
          user.features.find((f) => f.featureType === 0).isEnabled
      ),
  },
  {
    exact,
    path: "/reports",
    component: () =>
      secLayout(
        Reports,
        (user) =>
          user.tr_employeeId &&
          user.features &&
          user.features.length > 0 &&
          user.features.find((f) => f.featureType === 1) &&
          user.features.find((f) => f.featureType === 1).isEnabled
      ),
  },
  {
    exact,
    path: "/dashboard",
    component: () => secLayout(Dashboard),
  },
  {
    exact,
    path: "/client-forms",
    component: () => secLayout(ClientForms),
  },
  {
    exact,
    path: "/client-forms/report-breach",
    component: () => secLayout(ReportBreach),
  },
  {
    exact,
    path: "/client-forms/client-order",
    component: () =>
      secLayout(ClientOrder, (user) => checkSelfServicePermission(user)),
  },
  {
    exact,
    path: "/client-forms/client-order-completed",
    component: () =>
      secLayout(
        ClientOrderCompleted,
        (user) => (user) => checkSelfServicePermission(user)
      ),
  },
  {
    exact,
    path: "/client-forms/contact-client-care",
    component: () =>
      secLayout(ContactClientCare, (user) => checkSelfServicePermission(user)),
  },
  {
    exact,
    path: "/client-forms/contact-client-care-completed",
    component: () =>
      secLayout(
        ContactClientCareCompleted,
        (user) => (user) => checkSelfServicePermission(user)
      ),
  },
  {
    exact,
    path: "/client-account",
    component: () =>
      secLayout(
        ClientAccount,
        (user) => (user) => checkSelfServicePermission(user)
      ),
  },
  {
    exact,
    path: "/not-found",
    component: () => (
      <GenericError
        error={"Page not found"}
        errorImg={"not found"}
        errorFooterImg={oasisLogo}
      ></GenericError>
    ),
  },
  {
    exact,
    path: "/unauthorized",
    component: () => (
      <GenericError
        error={"Your permissions do not allow you to see this page"}
        errorImg={defaultErrorImg}
        errorFooterImg={oasisLogo}
      ></GenericError>
    ),
  },
];
